export enum ProductType {
  DEFAULT = 'default',
  EXPIRATION = 'expiration',
}
